export enum UIConstants {
  JACKET_FORMDETAIL_BORROWER_NAME_MAX_LENGTH = 255,
  CHECK_PROCESS_IN_PROGRESS_INTERVAL_MILISECONDS = 250, // 0.25 second
  WAITING_PROCESS_IN_PROGRESS_MAX_MILISECONDS = 30000, // 30 seconds
  FLASH_MESSAGE_AUTO_HIDDEN_DURATION = 8000, // 8 seconds
  LOADING_IN_PROGRESS_MESSAGE = "Please wait while your data is being prepared",
  LOADING_RECALC_PREMIUM_MESSAGE = "Please wait while we recalculate your premiums",
  SAVE_IN_PROGRESS_MESSAGE = "Please wait while saving your file",
  SAVE_DOCUMENT_IN_PROGRESS_MESSAGE = "Please wait while saving your policy document",
  SAVE_TITLE_SEARCH_DOCUMENT_IN_PROGRESS_MESSAGE = "Please wait while saving your document",
  SAVE_FILE_STATUS_MESSAGE = "Please wait while updating your File Status...",
  SAVE_PROFILE_IN_PROGRESS_MESSAGE = "Please wait while saving your profile",
  UNDO_REPORT_REQUEST_SUBMITTING_MESSAGE = "Please wait while submitting your request...",
  UNDO_REPORT_ERROR_MESSAGE = "There was a problem with the Undo Report button. Please try again or contact the Agency Support Center for assistance.",
  VIEW_DOCUMENT_ERROR_MESSAGE = "There was a problem displaying your document. Please try again or contact the Agency Support Center for assistance.",
  DOWNLOAD_DOCUMENT_ERROR_MESSAGE = "There was a problem displaying your document. Please try again or contact the Agency Support Center for assistance.",
  DOWNLOAD_ZIPFILE_ERROR_MESSAGE = "There was a problem downloading your documents. Please try again or contact the Agency Support Center for assistance.",

  EFFECTIVE_DATE_NOT_WITHIN_30_DAYS_ERROR_MESSAGE = "The Effective Date must be within 30 days.",
  EFFECTIVE_DATE_NOT_VALID_ERROR_MESSAGE = "The effective date is not valid based on the Agency's contract date.",
  ENDORSEMENT_NOT_VALID_FOR_SELECTED_EFFECTIVE_DATE = "The Endorsement is not valid for the selected Effective Date",
  LOCATION_NOT_VALID_FOR_SELECTED_EFFECTIVE_DATE = "The effective date is not valid for the selected Agency Location",

  FORM_NOT_VALID_FOR_SELECTED_EFFECTIVE_DATE = "The Form is not valid for the selected Effective Date.  Please Void the Jacket and Issue a New One.",

  JACKET_VOID_BLOCKED_BY_COLLATERAL_MORTGAGE_TITLE = "Cannot void this policy jacket",

  TITLE_SEARCH_SEND_MESSAGE_AND_DOCUMENT_IN_PROGRESS_MESSAGE = "Please wait while submitting your message/documents.",

  UNEXPECTED_ERROR_MESSAGE = 'An unexpected error has occurred.',
  
  SIGNATURE_CREATE_SUCCESS_MESSAGE = "Signature successfully added!",
  SIGNATURE_CREATE_ERROR_MESSAGE = "Signature creation failed!",

  SIGNATURE_UPDATE_SUCCESS_MESSAGE = "Signature successfully updated!",
  SIGNATURE_UPDATE_ERROR_MESSAGE = "Signature update failed!",

  SIGNATURE_DELETE_SUCCESS_MESSAGE = "Signature successfully deleted!",
  SIGNATURE_DELETE_ERROR_MESSAGE = "Signature deletion failed!", 

  AGENCY_UPDATE_SUCCESS_MESSAGE = "Agency access successfully updated!",
  AGENCY_UPDATE_ERROR_MESSAGE = "Agency access update failed!",

  VIEW_AGENCY_SETUP = 'View Agency Access',
  VIEW_AGENCY_ACCESS = 'View Agency Access',
  VIEW_SIGNATURE = 'View Signature',

  EDIT_AGENCY_SETUP = 'Edit Agency Access',
  EDIT_AGENCY_ACCESS = 'Edit Agency Access',
  EDIT_SIGNATURE = 'Edit Signature',

  FILE_SIZE_EXCEEDED_ERROR_MESSAGE = "The selected file exceeds the maximum allowed size of 1 MB",

  ADD_DEFAULT_SIGNATURE_SUCCESS_MESSAGE = "Default Signature successfully added!",
  ADD_DEFAULT_SIGNATURE_ERROR_MESSAGE = "Default Signature creation failed!",

  UPDATE_DEFAULT_SIGNATURE_SUCCESS_MESSAGE = "Default Signature successfully updated!",
  UPDATE_DEFAULT_SIGNATURE_ERROR_MESSAGE = "Default Signature update failed!",

  DELETE_DEFAULT_SIGNATURE_SUCCESS_MESSAGE = "Default Signature successfully deleted!",
  DELETE_DEFAULT_SIGNATURE_ERROR_MESSAGE = "Default Signature deletion failed!",
}

export enum DOMEventType {
  FILE_JUST_LOADED = "fileJustLoaded",
  APP_RELOAD_REQUIRED = "appReloadRequired",
}

export enum LocalStorageKeys {
  COLUMNS_FILES = "columns-files",
  COLUMNS_FILES_HIDDEN = "columns-files-hidden",
  COLUMNS_REPORT_PAY = "columns-report-pay",
  COLUMNS_REPORT_PAY_HIDDEN = "columns-report-pay-hidden",
  COLUMNS_PENDING_PAY = "columns-pending-pay",
  COLUMNS_PENDING_PAY_HIDDEN = "columns-pending-pay-hidden",
  COLUMNS_IMAGE_ARCHIVE = "columns-image-archive",
  COLUMNS_IMAGE_ARCHIVE_HIDDEN = "columns-image-archive-hidden",
  COLUMNS_SIGNATURE= "columns-signature-default",
  COLUMNS_MANAGE_SIGNATURE ="columns-signature-manage"
}

export enum SessionStorageKeys {
  APP_VERSION = "app-version",
  APP_VERSION_PENDING = "app-version-pending",
  APP_RELOAD_REQUIRED = "app-reload-required",
  FEATURE_CONFIG = "feature-config",
  GENERAL_CONFIG = "general-config",
  GLOBAL_ACCESS_SELECTED_AGENCY = "selectedAgency",
  USE_PRIOR_SEARCH_CRITERIA = "usePriorSearchCriteria",
  USE_PRIOR_SEARCH_CRITERIA_ADVANCE_SEARCH = "usePriorSearchCriteriaAdvanceSearch",
  REPORT_PAY_STORED_CRITERIA = "reportPayStoredCriteria",
  LIST_FILE_STORED_CRITERIA = "listFileStoredCriteria",
  PENDING_PAY_STORED_CRITERIA = "pendingPayStoredCriteria",
  SELECTED_FILES_REPORT_PAY = "selectedFilesReportPay",
  SELECTED_FILES_PENDING_PAY = "selectedFilesPendingPay",
  LANDING_PAGE = "landing_page"
}

export enum CreateFileProviderActionType {
  INIT = "INIT",
  UPDATE_PRICING_IN_PROGRESS = "UPDATE_PRICING_IN_PROGRESS",
}

export enum PaginationProviderActionType {
  INIT_SIGNATURE_DEFAULT_GRID = "INIT_SIGNATURE_DEFAULT_GRID",
  SET_SIGNATURE_DEFAULT_GRID = "SET_SIGNATURE_DEFAULT_GRID",
  INIT_SIGNATURE_GRID = "INIT_SIGNATURE_GRID",
  SET_SIGNATURE_GRID = "SET_SIGNATURE_GRID",

}


export enum ProductItemType {
  Endorsement = "ENDO",
  JacketAdditionalCharge = "JACKETADDLCHG",
  JacketSpecialCharge = "JACKETSPCLCHG",
}

export enum ProductTabNameExtension {
  PolicyUpload = "POLICY UPLOAD",
  UWARequest = "UWAREQUEST"
}

export enum ProductTabTitle {
  TitleSearch = "Title Search",
  Aal = "AAL",
  Cpl = "CPL",
  Jacket = "Jacket",
  StandaloneEndorsement = "Standalone Endorsement",
  UWARequest = "UW Approval Request",
  PolicyUpload = "Policy Upload",
}

export enum ProductSectionTitle {
  TitleSearch = "Title Search",
  Aal = "AAL",
  Cpl = "CPL",
  Jacket = "Jacket",
  StandaloneEndorsement = "Standalone Endorsement",
  UWARequest = "Underwriting Approval Request",
}

export enum ProductTabSortOrder {
  TitleSearch= 10,
  Aal = 20,
  Cpl = 20,
  Jacket = 30,
  StandaloneEndorsement = 40,
  UnderWriter = 50,
  PolicyUpload = 60,
}


export enum PolicyImageTabName {
  UploadImages = "Upload Images",
  ImageArchive = "Image Archive",
}

export enum JacketFormType {
  Binder = "Binder",
  Commitment = "Commitment",
  Guarantee = "Guarantee",
  Loan = "Loan",
  Owners = "Owners",
}

export enum JacketFormDetailName {
  "AddendumAttached" = "Addendum Attached",
  "BorrowerNamesAndVesting" = "Borrower Names and Vesting",
  "MortgageAmount" = "Mortgage Amount",
}

export enum OrderStatusType {
  Cancelled = "CANCELLED",
  Error = "ERROR",
  Issued = "ISSUED",
  Pending = "PENDING",
  UndoVoidPending = "UNDOVOIDPEND",
  Voided = "VOIDED",
  InProgress = "INPROGRESS",
  Completed = "COMPLETED",
  UpdateCompleted ="UPDATECOMPLETED",
  UpdatePending = "UPDATEPENDING",
  UpdateInProgress = "UPDATEINPROGRESS",
  UpdateCancelled =  "UPDATECANCELLED",
  UpdateCancelPending = "UPDATECANCELPENDING",
  Open = "OPEN",
  Hold = "HOLD",
  Approved = "APPROVED",
  ApprovedWithConditions = "APPROVEDWITHCONDITIONS",
  DeclineToInsure = "DECLINETOINSURE",
}

export enum EndorsementStatusType {
  Cancelled = "CANCELLED",
  Error = "ERROR",
  Issued = "ISSUED",
  Pending = "PENDING",
  Submitted = "SUBMITTED",
  Voided = "VOIDED",
}

export enum OrderStatusTypeName {
  Pending = "Pending",
  Issued = "Issued",
}

export enum UWARequestStatusType {
  Approved = "APPROVED",
  Cancelled = "CANCELLED",
  InProgress = "INPROGRESS",
}

export enum FileStatusType {
  Cancelled = "CANCELLED",
  Inactive = "INACTIVE",
  Open = "OPEN",
  OpenedInError = "OPENEDINERROR",
  ReportPaid = "REPORTEDPAID",
  ReportPending = "REPORTEDPENDING",
}

export enum ImageArchiveType {
  UploadDate = "UPLOADED_DATE",
}
export enum FileStatusTypeName {
  Cancelled = "Cancelled",
  Inactive = "Inactive",
  Open = "Open",
  OpenedInError = "Opened In Error",
  ReportPaid = "Reported/Paid",
  ReportPending = "Reported/Pending",
}

export enum ReportingOptionType {
  PayByCheck = "PAYBYCHECK",
  EPay = "EPAY",
  ReportOnly = "REPORTONLY",
  AutoReport = "AUTOREPORT",
}

export enum PaymentSheetOptionType {
  Default = "PRODUCT",  // for now
  File = "FILE",
  Product = "PRODUCT",
}

export enum MapActionType {
  SaveFile = "SaveFile",
  ProductAction = "ProductAction",
  RetrievePricingData = "RetrievePricingData",
  SaveJacketOPN = "SaveJacketOPN",
  CheckFormDirty = "CheckFormDirty",
  SaveFileStatus = "SaveFileStatus",
  TitleSearchResendToTPS = "TitleSearchResendToTPS",
}

export enum ProductAction {
  Issue = "Issue",
  IssueResend = "IssueResend",
  Revise = "Revise",
  Ppe = "Ppe",
  ReportPricing = "ReportPricing",
  UndoReport = "UndoReport",
  ReportAndPayByCheck = "ReportAndPayByCheck",
  CalculatePricing = "CalculatePricing",
  CalculateItem = "CalculateItem",
  CalculateItems = "CalculateItems",
  Void = "Void",
  UndoVoid = "UndoVoid",
  UndoRevise = "UndoRevise",
  Cancel = "Cancel",
  TitleSearchResendToTPS = "TitleSearchResendToTPS",
  None = "None",
}

export enum PartyType {
  Individual = "INDIVIDUAL",
  BusTrustEstate = "BUSTRUSTESTATE",
  Attorneys = "ATTORNEY",
  SettlementCompany = "SETTLEMENTCOMPANY",
  SecondaryAgency = "SECONDARYAGENCY",
}

export enum SearchPartyType {
  Attorney = "ApprovedAttorney",
  SettlementCompany = "SettlementCompany",
  SecondaryAgency = "SecondaryAgency",
}

export enum PartyRoleType {
  BuyerBorrower = "BUYER/BORROWER",
  Seller = "SELLER",
  Lender = "LENDER",
  AdditionalParty = "ADDITIONALPARTY",
}

export enum PartyRoleTypeName {
  BuyerBorrower = "Buyer/Borrower",
  Seller = "Seller",
  Lender = "Lender",
  AdditionalParty = "ADDITIONAL PARTY",
}

export enum ProductType {
  AllProducts = "",
  Aal = "AAL",
  Cpl = "CPL",
  Jacket = "JACKET",
  Endorsement = "ENDORSEMENT", // not part of table lookup
  StandaloneEndorsement = "SAENDO",
  TitleSearch="TITLESEARCH",
  UWARequest="UWAREQUEST",
}

export enum InputMethod {
  Currency = "Currency",
  Date = "Date",
  DropDown = "Dropdown",
  Number = "Number",
  RadioButton = "RadioButton",
  Text = "Text",
}

export enum ProductTypeName {
  CPL = "CPL",
  AAL = "AAL",
  JACKET = "Jacket",
  STANDALONE_ENDORSEMENT = "Standalone Endorsement",
  TITLE_SEARCH = "Title Search",
  UWARequest = "UW Approval Request",
}

export enum SequenceType {
  First = "FIRST",
  Second = "SECOND",
}

export enum IssueType {
  All = "All",
  Single = "Single",
}

export enum PricingColumnName {
  Product = "Product",
  ActualFee = "ActualFee",
  RiskRate = "ActualRiskRate",
  AgentRetention = "AgentRetention",
  TotalDue = "TotalDue",
}

export enum Country {
  USA = "840",
}

export enum RemittanceSplitType {
  Flat = "FLAT %",
  CentPerThousand = "CENTS PER THOUSAND",
  Staggered = "STAGGERED",
}

export enum DateTypeCode {
  Created = "CREATED_DATE",
  Modified = "MODIFIED_DATE",
  EffectiveDate = "EFFECTIVE_DATE",
  IssueDate = "ISSUE_DATE",
  ReportedDate = "BILLED_DATE",
  UploadDate = "UPLOADED_DATE",
}

export enum CacheKey {
  MsalInstance = "STEWART_MSAL_INSTANCE",
}

export enum PricingType {
  All = "All",
  Product = "Product",
  ProductItem = "ProductItem",
  AdditionalCharge = "AdditionalCharge",
  SpecialCharge = "SpecialCharge",
  Tax = "Tax",
}

export enum PricingProductSortOrder {
  JacketLoanOwner = "01",
  JacketOther = "02",
  CPL = "03",
  AAL = "04",
  StandaloneLoanOwner = "05",
  StandaloneOther = "06",
  FileSpecialCharge = "99",
}

export enum PricingProductSortOrder2 {
  Product = 1,
  Endorsement = 2,
  AdditionalCharge = 3,
  SpecialCharges = 4,
  Tax = 9,
}

export enum NotificationType {
  Info = "Info",
  Error = "Error",
}

export enum PricingConfigKey {
  IsIntegratedPricing = "IsIntegratedPricing",
  DefaultErrorMessage = "DefaultErrorMessage",
  RiskRate = "RiskRate",
  ReIssue = "ReIssue",
  ReIssueEdit = "Pricing:ReIssue:Edit",
  SimultaneousRate = "SimultaneousRate",
  InfoMsgRateType = "InfoMsg:RateType",
  InfoMsgReIssue = "InfoMsg:ReIssue",
  ThresholdMessage = "ThresholdMessage",
  TaxCode = "Tax",
  TaxDocument = "TaxCodesDocument",
  LiabilityLimit = "LiabilityLimit",
  LiabilityLabel = "OPN:Liability:Label",
  OPNLiability = "OPN:Liability",
  OPNCoverageType = "OPN:CoverageType",
  OPNCoverageTypeLabel = "OPN:CoverageType:Label",
  OPNPolicyDate = "OPN:PolicyDate",
  OPNPolicyDateLabel = "OPN:PolicyDate:Label",
  OPNPrevPolicyLast10Yrs = "OPN:PrevPolicyLast10Yrs",
  OPNWindowTitle = "OPN:Window:Title",
  TransCode = "TransCode",
  Leasehold = "Leasehold",
  ReIssueLabel = "Pricing:ReIssue:Label",
  ReIssueLabelText = "Pricing:ReIssue:LabelText",
  CheckBox = "Pricing:ReIssue:Checkbox",
  CoInsurance = "CoInsurance",
  CallStrafeForRemittance = "CallStrafeForRemittance",
  JacketFormDefault = "DefaultForm",
  JacketTransCodeDefault = "DefaultTransCode",
  MultipleLoans = "MultipleLoans",
  CPLLiability = "CPL:Liability",
  DisplayFileSpecialCharge = "DisplayFileSpecialCharge",
}

export enum TaxCodeSearchBy {
  City = "city",
  County = "county",
  Default = "DEFAULT",
}

export enum TaxCodePremium {
  Default = "9998",
}

export enum VoidReason {
  CreatedInError = "Created in Error",
  EnteredInError = "Entered in Error",
}

export enum ReportAndPayAction {
  ReportOnly = "REPORTONLY",
  ReportAndPayByCheck = "REPORTANDPAYBYCHECK",
  PayByCheck = "PAYBYCHECK",
}

export enum ReportType {
  ReportOnly = "REPORTONLY",
  ReportPayCheck = "PAYBYCHECK",
  ReportPayEPay = "EPAY",
  AutoReport = "AUTOREPORT",
}

export enum FilesSearchCriteriaType {
  Search = "Search",
  AdvancedSearch = "AdvancedSearch",
}

export enum PaymentsFileExportCriteriaType {
  ReportAndPayCriteria = "ReportAndPayCriteriaSearch",
  ReportAndPayKeyword = "ReportAndPayKeywordSearch",
  PendingPaymentsCriteria = "PendingPaymentsCriteriaSearch",
  PendingPaymentsKeyword = "PendingPaymentsKeywordSearch",
}

export enum RuleCondition {
  IsRequired = "IsRequired",
  IsAllowed = "IsAllowed",
  IsNotAllowed = "IsNotAllowed",
}

export enum OverrideReasonType {
  CoInsurance = "COINSURANCE",
}

export enum CompanyContractDateStatus {
  Active = "Active",
  Amended = "Amended",
  Cancelled = "Cancelled",
}

export enum PageType {
  MyFilesPage = "MYFILESPAGE",
  ReportPayPage = "REPORTPAYPAGE",
  PendingPayPage = "PENDINGPAYPAGE",
  ImageArchive = "IMAGEARCHIVE"
}

export enum SiteErrorType {
  BadAccount = "BADACCOUNT",
  PasswordExpired = "PASSWORDEXPIRED",
  NetworkError = "NETWORK",
  NotFound = "NOTFOUND",
  ErrorBoundary = "ERRORBOUNDARY",
  Exception = "EXCEPTION",
  NoAccess = "NOACCESS",
  NoModuleAccess = "NOMODULEACCESS",
  // PermissionDenied = "PERMISSIONDENIED",
}

export enum UserRequestAuthorizationType {
  Authorized = "AUTHORIZED",
  ProvidedAuthorization = "PROVIDED_AUTHORIZATION",
  NotAuthorized = "NOT_AUTHORIZED",
}

export enum DownloadFileType {
  csv = "csv",
  doc = "doc",
  docx = "docx",
  jpeg = "jpeg",
  jpg = "jpg",
  mp4 = "mp4",
  msg = "msg",
  pdf = "pdf",
  png = "png",
  rtf = "rtf",
  tif = "tif",
  tiff = "tiff",
  txt = "txt",
  xls = "xls",
  xlsx = "xlsx",
  xml = "xml",
}

export enum AgencyStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export enum SignatureLevelType {
  AgencyWide = "AGENCY_WIDE",
  UserOnly = "USER_ONLY"
}

export enum PERMISSIONS {
  CREATE_FILE_ACCESS = "CREATE_FILE_ACCESS",
  HELP_ACCESS = "HELP_ACCESS",
  VIEW_BILLING = "VIEW_BILLING",
  POLICYIMAGES_ACCESS = "POLICYIMAGES_ACCESS",
  RESOURCES_ACCESS = "RESOURCES_ACCESS",
  VIEW_REPORTS = "VIEW_REPORTS",
  POLICYIMAGES_SEARCH = "POLICYIMAGES_SEARCH",
  POLICYIMAGES_DELETE = "POLICYIMAGES_DELETE",
  POLICYIMAGES_MODIFY = "POLICYIMAGES_MODIFY",
  SIGNATURES_MANAGE = "SIGNATURES_MANAGE",
  EXPORT_DATA_PORTAL = "EXPORT_DATA_PORTAL",
  POLICYIMAGES_VIEWDOCS = "POLICYIMAGES_VIEWDOCS",
  SITE_ACCESS = "SITE_ACCESS",
  ADMIN_ACCESS = "ADMIN_ACCESS",
  POLICY_ACCESS = "POLICY_ACCESS",
  BILLING_VIEW = "BILLING_VIEW",
  BILLING_MODIFY = "BILLING_MODIFY",
  BILLING_REPORT = "BILLING_REPORT",
  BILLING_UNDOREPORT = "BILLING_UNDOREPORT",
  BILLING_RPTPAYCHECK = "BILLING_RPTPAYCHECK",
  BILLING_EXCLAUTORPT = "BILLING_EXCLAUTORPT",
  FILES_VIEW = "FILES_VIEW",
  FILES_MODIFY = "FILES_MODIFY",
  FILES_SEARCH = "FILES_SEARCH",
  SIGNATURES_EDIT = "SIGNATURES_EDIT",
  SIGNATURES_ADD = "SIGNATURES_ADD",
  SIGNATURES_DELETE = "SIGNATURES_DELETE",
  SIGNATURES_EDIT_AGENCYSETUP = "SIGNATURES_EDIT_AGENCYSETUP",
  SIGNATURES_EDIT_USERONLY = "SIGNATURES_EDIT_USERONLY",
  HELP_ACCESS_CREATE_TICKET = "HELP_ACCESS_CREATE_TICKET",
  HELP_ACCESS_FAQ = "HELP_ACCESS_FAQ",
  HELP_ACCESS_NEW_USER = "HELP_ACCESS_NEW_USER",
  HELP_ACCESS_QRC = "HELP_ACCESS_QRC",
  HELP_ACCESS_RELEASENOTES = "HELP_ACCESS_RELEASENOTES",
  TITLESEARCH_HIDEUNHIDEMESSAGES ="TITLESEARCH_HIDEUNHIDEMESSAGES",
  TITLESEARCH_HIDEUNHIDEDOCS ="TITLESEARCH_HIDEUNHIDEDOCS",
  TITLESEARCH_RESEND = "TITLESEARCH_RESEND",
  CPL_REPORT_ONLY ="CPL_REPORT_ONLY",
  UWA_VIEW = "UWA_VIEW",
  UWA_ADDREQUEST = "UWA_ADDREQUEST",
  UWA_ADDPOLICY = "UWA_ADDPOLICY",
  UWA_SUBMIT = "UWA_SUBMIT",
  UWA_REVISE = "UWA_REVISE",
  UWA_CANCEL = "UWA_CANCEL",
  UWA_UNDOCANCEL = "UWA_UNDOCANCEL",
  UWA_VIEWSUMMARY = "UWA_VIEWSUMMARY",
  UWA_SENDMESSAGEDOC  ="UWA_SENDMESSAGEDOC",
  UNDOVOID_JACKET = "UNDOVOID_JACKET",
  TITLESEARCH_EDITORDERNUMBER = "TITLESEARCH_EDITORDERNUMBER",
  AGENCY_CANCEL_FILE_ACCESS = "AGENCY_CANCEL_FILE_ACCESS",
}

export enum ProgressImageType {
  linear = "LinearProgress",
  circular = "CircularProgress",
}

export enum NavigateToType {
  Url = "URL",
  Tab = "TAB",
  Button = "BUTTON",
  Adb2c = "ADB2C",
}

export enum ActionResultStatus {
  Success = 'SUCCESS',
  Failed = 'FAILED',
}

export enum ValidationStatus {
  Valid = 'VALID',
  InValid = 'INVALID',
}

export enum DocumentType {
  POLICY = "POLICY",
  TITLEDOCS = "TITLEDOCS",
  TITLESEARCHDOC = "TITLESEARCHDOC",
  TITLESEARCHDATA = "TITLESEARCHDATA",
  FILE = "FILE",
  SIGNATURE = "SIGNATURE",
}

export enum FileSizeType {
  KiloByte = "KB",
  MegaByte = "MB",
}

export enum TransactionType {
  PURCHASE = "PURCHASE",
  REFINANCE = "REFINANCE"
}

export enum TitleSearchTransacionType {
  InformationOnly = "Information Only"
}

export enum FlashMessageType {
  Success = 'SUCCESS',
  Information = 'INFORMATION',
  Warning = 'WARNING',
  Error = 'ERROR'
}

export enum TitleSearchProcessedStatusType {
  SCFileCreated = "SCFileCreated",
  Dropped2SB = "Dropped2SB",
  RWFileCreated = "RWFileCreated",
  RWCompleted = "RWCompleted",
  RWFailed = "RWFailed"
}

export enum MessageType {
  Message = "MESSAGE",
  NoteDoc = "NOTEDOC",
  Action = "ACTION",
}

export enum ExternalTPS {
  Qualia = "Qualia",
}

export enum InternalTPS {
  Resware = "Resware",
}

export enum OriginationSourceMaskName {
  StewartTitleProduction = "Stewart Title Production",
}

export enum OriginationSource {
  Default = "Stewart Connect",
}

export enum UWASpecialRisk {
  IsConstructionLoan = "IsConstructionLoan",
  IsBrokenPriority = "IsBrokenPriority",
  IsRecentConstruction = "IsRecentConstruction",
  HasMechanicsLienCoverageRequest = "HasMechanicsLienCoverageRequest",
  IsTidelands = "IsTidelands",
  IsRailroadProperty = "IsRailroadProperty",
  IsJudicialProceeding = "IsJudicialProceeding",
  IsForeclosure = "IsForeclosure",
  HasMineralCoverage = "HasMineralCoverage",
  IsLoanConstructionForeclosure = "IsLoanConstructionForeclosure",
  IsEasementIndependantOfProperty = "IsEasementIndependantOfProperty",
  HasInsuredOption = "HasInsuredOption",
  IsNativeAmericanLand = "IsNativeAmericanLand",
  HasWaterRights = "HasWaterRights",
  HasSheriffSale = "HasSheriffSale",
  IsInsuringRecordedLien = "IsInsuringRecordedLien",
  IsAssignmentOfInterest = "IsAssignmentOfInterest",
  HasPurchaseContract = "HasPurchaseContract",
  HasRelianceOnIndemnity = "HasRelianceOnIndemnity",
  HasSurveyConcerns = "HasSurveyConcerns",
  IsOwnerOutOfPossession = "IsOwnerOutOfPossession",
  HasOtherExtraHazardRisk = "HasOtherExtraHazardRisk",
  HasLitigation = "HasLitigation",
  HasTransactionTurnedDown = "HasTransactionTurnedDown",
  IsEnergyProject = "IsEnergyProject",
  IsCannabisProject = "IsCannabisProject",
  IsHardMoney = "IsHardMoney",
  HasUnusualCoverages = "HasUnusualCoverages",
  HasCoInsurance = "HasCoInsurance",
}

export enum IncludeAgencyConfiguration {
  Yes = 0,
  No = 1
}